import { render, staticRenderFns } from "./CancelPolicy.vue?vue&type=template&id=1af83f30&"
import script from "./CancelPolicy.vue?vue&type=script&lang=js&"
export * from "./CancelPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
installComponents(component, {VDivider,VOverlay})
